import { CultureInfo } from '../culture-info.model';
import { CultureInfoSrLatn } from './sr-Latn';

/**
 * @ignore
 */
export const CultureInfoSrLatnME: CultureInfo = {
  name: 'sr-Latn-ME',
  displayName: 'Serbian (Latin, Montenegro)',
  iso3LanguageCode: 'srp',
  iso2LanguageCode: 'sr',
  ietfLanguageTag: 'sr-Latn-ME',
  parent: CultureInfoSrLatn
};
